import { CompanyInfoInner } from './CompanyInfoInner'
import { useUser } from '~/@biz_account/useUser/useUser'

function CompanyInfo() {
  const { user } = useUser()
  const hasUserSignedContract = user?.onboarding?.currentRequiredStep === null
  if (!user?.profile?.isCompany && hasUserSignedContract) {
    return null
  }

  return <CompanyInfoInner hasUserSignedContract={hasUserSignedContract} />
}

export { CompanyInfo }
